<template>
  <div class="va-row">
    <div class="flex md12 xs12">      
      <vuestic-widget id="datagridSettlement">
        <div class="flex md4" id="createNewSettlement" style="padding-top: 0;padding-left: 0;">
          <button class="btn btn-primary btn-sm" @click="goApplySettlement">
            <div class="btn-with-icon-content">
              <i class="iconicstroke iconicstroke-plus"></i>
              {{$t('basic.button.newSettlement')}}
            </div>
          </button>
        </div>
        <vuestic-data-table2
          :apiUrl="apiUrl"
          :data="apiData"       
          :httpMethod="httpMethod"
          :tableFields="tableFields"
          :itemsPerPage="itemsPerPage"
          :defaultPerPage="defaultTablePerPage"
          :sortFunctions="sortFunctions"
          :apiMode="apiMode"
          :paginationPath="paginationPath"
          :queryParams="queryParams"
          :filterSelectShown="searchBarVisible"
        >
          <spring-spinner
            slot="loading"
            :animation-duration="2500"
            :size="70"
            color="#4ae387"
          />
        </vuestic-data-table2>
      </vuestic-widget>
    </div>

    <vuestic-modal :show.sync="openFg" v-bind:large="true" ref="largeModal" id="detailModal" :noButtons="true">
      <div slot="title">{{ 'settlement_details.title' | translate}}&nbsp;&nbsp;{{ 'settlement_details.of' | translate}}&nbsp;&nbsp;{{ 'settlement_details.settlementId' | translate}}&nbsp;&nbsp;"{{this.settlementId}}"</div>
      <settlement-details :table-data="currentSelectedDetail"></settlement-details>
    </vuestic-modal>
    
  </div>
</template>

<script>
import Vue from 'vue'
import { request } from '@/utils/utils';
import CountriesList from "data/CountriesList";
import FieldsDef from './FieldsDef.js'
import ItemsPerPageDef from '@/vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition'
import QueryParams from '@/vuestic-theme/vuestic-components/vuestic-datatable/data/query-params'
import { SpringSpinner } from 'epic-spinners'
import VuesticDataTable2 from '@/vuestic-theme/vuestic-components/vuestic-datatable/VuesticDataTable2'
import SettlementDetails from './settlementDetails'
export default {
  name: "Settlement",
  components: {
    SpringSpinner,
    VuesticDataTable2,
    SettlementDetails
  },
  data() {
    return {
      searchBarVisible: false,
      pageNo: 1,
      pageSize: 6,
      apiUrl: '',
      httpMethod: 'post',
      apiData: {},
      apiMode: true,
      tableFields: FieldsDef.tableFields,
      itemsPerPage: ItemsPerPageDef.itemsPerPage,
      defaultTablePerPage: 2,
      sortFunctions: FieldsDef.sortFunctions,
      paginationPath: '',
      queryParams: QueryParams,
      openFg: false,
      settlementId: '',
      currentSelectedDetail: [
        {2:'', 16: '', 20: ''},
        {2:'', 16: '', 20: ''}
      ]
    };
  },
  mounted() {
    this.apiUrl = `${process.env.VUE_APP_API_ROOT}/api/dashboard/settle/list?access_token=${localStorage.getItem('Authorization')}&pageNum=${this.pageNo}&pageSize=${this.pageSize}`;
    this.init();
    this.getAllData();
    this.$root.$on('openModel', (obj) => {
      this.currentSelectedDetail = [
        {2:'', 16: '', 20: ''},
        {2:'', 16: '', 20: ''}
      ]
      this.showDetails(obj)
    })
    this.$root.$on('updatePageNo', (pageNo) => {
      this.pageNo = pageNo;
      this.apiUrl = `${process.env.VUE_APP_API_ROOT}/api/dashboard/settle/list?access_token=${localStorage.getItem('Authorization')}&pageNum=${this.pageNo}&pageSize=${this.pageSize}`;
    })
  },
  methods: {
    init () {
      if (this.$refs.selInput) { 
        this.$refs.selInput.$el.getElementsByTagName('input')[0].readOnly = true
        this.$refs.selInput.$el.getElementsByTagName('input')[0].value = "ALL";
      }
    },
    showDetails(obj) {
      this.settlementId = obj.id;
      this.openFg = true;
      if(this.$refs.largeModal && this.openFg) {
        this.$refs.largeModal.open()
      } 
      this.findDetail(obj.id)
    },
    findDetail(id) {
      for(let i =0;  i < this.apiData.list.length; i++) {
        if(this.apiData.list[i].settlement_id === id) {
          try {
            this.currentSelectedDetail =  JSON.parse(this.apiData.list[i].report_detail)
            break;
          } catch (error) {}
        }
      }
    },
    getAllData() {
      // 获取所有的 结算列表数据
      let token = localStorage.getItem('Authorization')
      request({
        method: 'post',
        url: this.apiUrl,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
      .then(res => {
        if(res.status === 200) {
          this.apiData = res.data;
        }
      })
      .catch(err => {
        console.log(err);
      })
    },
    goApplySettlement() {
      // 跳转到新增交易申请页面
      this.$router.push({
        name: 'NewSettlement',
      })
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .vuetable-th-REPORT {
  text-align: right;
  padding-right: 10px;
}
/deep/ .btn {
  text-transform: none;
}
/deep/ .vertical-center-modal {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: start;;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
/deep/ .ivu-icon.ivu-icon-ios-close {
  font-size: 60px;
  top: -5px;
  right: -5px;
}
/deep/ .vuestic-modal .modal-header {
  padding: 0 0.3rem 0 1.2rem;
}
/deep/ .vuestic-modal .close-modal {
  font-size: 2.8rem;
  margin: -0.8rem 0 0 0;
}
/deep/ .modal-body {
    padding: 10px;
}
/deep/ #detailModal .va-row .flex {
  padding: 0.3rem 0.4rem 0.2rem 0.4rem;
}
/deep/ #detailModal .vuestic-widget .vuestic-widget-body {
  padding: 0;
}
/deep/ .modal-container .modal-dialog.modal-lg {
  width: 100%;
}
/* /deep/ .table-responsive {
  height: 400px;
} */
/deep/ .flex-center {
  margin-top: 80px;
}
@media only screen and (max-width: 750px) {
  /deep/ #datagridSettlement.vuestic-widget .vuestic-widget-body {
    padding: 0.2rem;
    .vuestic-data-table.table-responsive {
      overflow-x: auto;
    }
  }
  #createNewSettlement {
    padding-top: 10px !important;
    padding-left: 10px !important;
  }
  /deep/ .flex-center {
    margin-top: 40px;
    margin-bottom: 20px;
  }
}
</style>
